import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { AccountEffects } from './account.effects';
import { accountReducer } from './account.reducer';
import { AccountDataService } from '../account-data.service';

/**
 * Standalone providers for the `accounts` NgRx feature slice (SEOMS-437).
 * Replaces the former `AccountStoreModule`, preserving its AccountDataService
 * provision.
 */
export function provideAccountsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('accounts', accountReducer),
    provideEffects([AccountEffects]),
    AccountDataService,
  ]);
}
